import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

import { Subscription } from 'rxjs'
import { TouaregControlDisplayService } from '../../services/touareg-control-display.service'
import {
  HealthMonitorData,
  HealthMonitorSettings,
  TouaregControlStateHealthMonitorService,
} from '../../services/touareg-control-state-health-monitor.service'
import { CommonsModule } from '@/modules/commons/commons.module';
@Component({
  selector: 'app-touareg-control-health',
  templateUrl: './touareg-control-health.component.html',
  styleUrls: ['./touareg-control-health.component.scss'],
  imports: [CommonsModule],
})
export class TouaregControlHealthComponent implements OnInit, OnDestroy {
  @Output() close = new EventEmitter<MouseEvent>()

  private _healthSubs$!: Subscription
  private _healthMaxMsSubs$!: Subscription

  public health: HealthMonitorData = {} as HealthMonitorData
  public healthSettings: HealthMonitorSettings = {} as HealthMonitorSettings
  public show: boolean = false

  public pingLatency: string
  public descriptionPingLatency: string
  public stateUpdateBfs: string
  public descriptionStateUpdateBfs: string
  public timeShift: string
  public descriptionTimeShift: string
  public dateOffset: string
  public descriptionDateOffset: string

  constructor(
    private _monitor: TouaregControlStateHealthMonitorService,
    public displayService: TouaregControlDisplayService,
    private translate: TranslateService
  ) {
    this.pingLatency = this.translate.instant('touareg.pingLatency')
    this.descriptionPingLatency = this.translate.instant(
      'touareg.descriptionPingLatency'
    )
    this.stateUpdateBfs = this.translate.instant('touareg.stateUpdateBfs')
    this.descriptionStateUpdateBfs = this.translate.instant(
      'touareg.descriptionStateUpdateBfs'
    )
    this.timeShift = this.translate.instant('touareg.timeShift')
    this.descriptionTimeShift = this.translate.instant(
      'touareg.descriptionTimeShift'
    )
    this.dateOffset = this.translate.instant('touareg.dateOffset')
    this.descriptionDateOffset = this.translate.instant(
      'touareg.descriptionDateOffset'
    )
  }

  ngOnInit(): void {
    this._healthMaxMsSubs$ = this._monitor.healthMonitorSettings$.subscribe(
      (maxMs) => {
        this.healthSettings = maxMs
      }
    )

    this._healthSubs$ = this._monitor.health$.subscribe((health) => {
      this.health = health || ({} as HealthMonitorData)
    })
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (!!this._healthSubs$) this._healthSubs$.unsubscribe()
    if (!!this._healthMaxMsSubs$) this._healthMaxMsSubs$.unsubscribe()
  }
}
